import "./utils/polyfills";
import ReactDOM from "react-dom/client";
import "./index.css";
import * as Sentry from "@sentry/react";
import { ThemeProvider } from "./theme";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { TitleProvider } from "./modules/core/providers/titleProvider";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <>
    <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
      <ThemeProvider defaultTheme="light">
        <TitleProvider baseTitle="CRESO">
          <App />
        </TitleProvider>
      </ThemeProvider>
    </Sentry.ErrorBoundary>
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
